import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTES } from '../constants';
import { IOffreResponse } from '../models/offre.model';

@Injectable({
  providedIn: 'root'
})
export class OffreService {

  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get all offres
   * @returns
   */
  getAll(): Observable<IOffreResponse> {
    return this.httpClient.get<IOffreResponse>(`${ROUTES.offre.list}`);
  }

  /**
   * Get one offre
   * @returns
   */
  getOne(id: number): Observable<IOffreResponse> {
    return this.httpClient.get<IOffreResponse>(`${ROUTES.offre.list}/${id}`);
  }
}
